import { type SagaIterator } from "@redux-saga/core";
import getShipmentTracking from "../../services/shipmentTracking/shipmentTracking.api";
import { shipmentTrackingActions } from "./slice";
import { call, put, takeLatest } from "redux-saga/effects";
import { showSnackbar } from "../snackbar/slice";
import { withLoader } from "../loader/saga";

interface ShipmentTrackingAction {
  type: string;
  payload: { orderId: string };
}

export function* handleFetchShipmentTracking(
  action: ShipmentTrackingAction
): SagaIterator {
  try {
    yield put(
      shipmentTrackingActions.fetchShipmentTrackingStart({
        orderId: action.payload.orderId,
      })
    );
    const response = yield* withLoader(function* () {
      return yield call(getShipmentTracking, action.payload.orderId);
    });

    const trackingId = response?.data?.erpTrackingNumber;
    const message = response?.message;
    if (!response?.data) {
      yield put(shipmentTrackingActions.fetchShipmentTrackingFailure(message));
      yield put(showSnackbar({ message, severity: "info" }));
      return;
    }

    if (trackingId) {
      yield put(
        shipmentTrackingActions.fetchShipmentTrackingSuccess({ trackingId })
      );
      window.open(
        `https://wwwapps.ups.com/tracking/tracking.cgi?tracknum=${trackingId}`,
        "_blank"
      );
    } else {
      yield put(
        shipmentTrackingActions.fetchShipmentTrackingFailure(
          message || "Tracking ID not found."
        )
      );
    }
  } catch (error: any) {
    yield put(
      shipmentTrackingActions.fetchShipmentTrackingFailure(
        error.message || "API error"
      )
    );
  }
}

export function* shipmentWatcherSaga(): SagaIterator {
  yield takeLatest(
    shipmentTrackingActions.fetchTracking.type,
    handleFetchShipmentTracking
  );
}

export default shipmentWatcherSaga;
